//电站列表
export const SELECT_PSIDS='alarm/psinfolist/SELECT_PSIDS';